import * as React from "react";

export class Cell extends React.Component<{
    colSpan?: number;
    additionalClassNames?: string;
}, {}> {
    baseClass: string;

    constructor(props) {
        super(props);
        this.baseClass = "rj-table__cell";
    }

    render() {
        const cls = this.baseClass +
        (this.props.additionalClassNames ? ` ${this.props.additionalClassNames}` : "");
        return (
            <td colSpan={this.props.colSpan} className={cls}>
                {this.props.children}
            </td>
        );
    }
}